import { create } from "zustand";

interface useMaintenanceStorePropEntity {
    isShow: boolean;
    message: string;
    setUpdateStatus: (isShow: boolean, message: string) => void
}

export const useMaintenanceStore = create<useMaintenanceStorePropEntity>((set) => ({
    isShow: false,
    message: "",
    setUpdateStatus: (isShow, message) => set((state) => ({ isShow, message }))
}))